import { AxiosError } from 'axios';
import { UseFormSetError } from 'react-hook-form';
import { toast } from 'sonner';

interface ApiErrorResponse {
  message?: string;
  error?: string;
  errors?: Record<string, string[]>;
}

export const useApiError = () => {
  /**
   * Para formulários com React Hook Form (setError do RHF)
   */
  const handleApiError = (
    error: unknown,
    setError?: UseFormSetError<any>
  ) => {
    if (error instanceof AxiosError) {
      const responseData = error.response?.data as ApiErrorResponse;

      // Handle validation errors
      if (error.response?.status === 422 && responseData?.errors && setError) {
        Object.entries(responseData.errors).forEach(([field, messages]) => {
          setError(field, {
            type: 'server',
            message: Array.isArray(messages) ? messages[0] : messages,
          });
        });
        return;
      }

      // Handle other errors
      const message = responseData?.message || responseData?.error || 'Erro interno do servidor';
      toast.error(message);
    } else {
      toast.error('Erro inesperado. Tente novamente.');
    }
  };

  /**
   * Para formulários com state simples (useState)
   * Retorna true se havia field errors (422), false caso contrário
   */
  const handleApiFieldError = (
    error: unknown,
    setFieldErrors: React.Dispatch<React.SetStateAction<Record<string, string>>>
  ): boolean => {
    if (error instanceof AxiosError) {
      const responseData = error.response?.data as ApiErrorResponse;

      if (error.response?.status === 422 && responseData?.errors) {
        const mapped: Record<string, string> = {};
        Object.entries(responseData.errors).forEach(([field, messages]) => {
          mapped[field] = Array.isArray(messages) ? messages[0] : String(messages);
        });
        setFieldErrors(mapped);
        return true;
      }

      // Non-field error → toast
      const message = responseData?.message || responseData?.error || 'Erro interno do servidor';
      toast.error(message);
    } else {
      toast.error('Erro inesperado. Tente novamente.');
    }
    return false;
  };

  return { handleApiError, handleApiFieldError };
};